<div class="no_data_image_container flex flex-col items-center justify-center gap-4 ">
    <img DefaultImage [src]="imageSrc" alt="" [style]="imgeStyles" referrerpolicy="no-referrer" [default]="default" />
    <button [class]="buttonStyle" (click)="OnClick()"> {{btnText}}</button>
</div>